// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"9cc7d271","164":"01201422","254":"e926aab7","301":"11e6644b","444":"38f81505","453":"264daa02"}[chunkId] + ".chunk.js";
};